import React from 'react';
import i18n from 'i18n-js';

const DuplicatedTabMessage = () => {
    return(
        <div className="m-alert m-alert--icon m-alert--icon-solid m-alert--outline alert alert-info alert-dismissible fade show" role="alert">
            <div className="m-alert__icon">
                <i className="flaticon-exclamation-1" ></i>
                <span></span>
            </div>
            <div className="m-alert__text">
                <strong>{ i18n.t('messages.duplicated_tab_title') }</strong>&nbsp;
                { i18n.t('messages.duplicated_tab_message') }
            </div>
            <div className="m-alert__close">
                <button type="button" className="close" data-dismiss="alert" aria-label="Close"></button>
            </div>
        </div>
    );
};

export default DuplicatedTabMessage;
